/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CaregiverInTravelRequestDto } from '../models/CaregiverInTravelRequestDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class CaregiverService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param caregiverId
     * @returns CaregiverInTravelRequestDto
     * @throws ApiError
     */
    public caregiverGetCaregiverTravelRequests(
        caregiverId: number,
    ): Observable<Array<CaregiverInTravelRequestDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/caregivers/{caregiverId}/TravelRequests',
            path: {
                'caregiverId': caregiverId,
            },
        });
    }
}
